// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* This file is shared between SaviyntQuill and SaviyntRenderQuillDelta */
/* ============ SaviyntQuill (Editor) ============ */
.SaviyntQuill {
  display: flex;
  flex-direction: column;
  min-height: 20rem;
  width: 100%;
}
.SaviyntQuill--isQuillInitializing .SaviyntQuill-editor,
.SaviyntQuill--isQuillInitializing .ql-toolbar,
.SaviyntRenderQuillDelta--isQuillInitializing .ql-editor {
  display: none;
}
.SaviyntQuill-loading,
.SaviyntRenderQuillDelta-loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  min-height: 20rem;
  height: 100%;
  width: 100%;
}
.SaviyntRenderQuillDelta-loading {
  min-height: 3rem;
}
/* Toolbar */
.SaviyntQuill.SaviyntQuill .ql-toolbar {
  font: var(--typography-body-2);
  color: var(--color-foreground-neutral-bold, #212328);
  background: var(--color-background-neutral-subtlest, #fff);
  border: 1px solid var(--color-border-secondary-subtlest, #cfd9e9);
  border-bottom: 0;
  border-radius: var(--border-radius-xs, 0.25rem)
    var(--border-radius-xs, 0.25rem) 0 0;
}
.SaviyntQuill.SaviyntQuill .ql-toolbar .ql-picker.ql-expanded .ql-picker-label {
  border-radius: var(--border-radius-xs, 0.25rem);
  border: 1px solid var(--color-border-secondary-medium, #254b86);
  background: var(
    --color-background-secondary-on-subtle-selected,
    rgba(37, 75, 134, 0.1)
  );
}
/* Placeholder text */
.SaviyntQuill .ql-editor.ql-blank::before {
  font: var(--typography-body-2);
  color: var(--color-foreground-neutral-subtle, #717385);
}
/* Base */
.SaviyntQuill.SaviyntQuill .ql-stroke,
.SaviyntQuill.SaviyntQuill .ql-color .ql-picker-label svg .ql-stroke,
.SaviyntQuill.SaviyntQuill .ql-background .ql-picker-label svg .ql-stroke,
.SaviyntQuill.SaviyntQuill .ql-even,
.SaviyntQuill.SaviyntQuill .ql-fill {
  stroke: var(--color-foreground-primary-medium, #3751ff);
}
.SaviyntQuill.SaviyntQuill g.ql-fill {
  stroke: var(
    --color-background-neutral-on-bold-hover,
    rgba(255, 255, 255, 0.24)
  );
}
.SaviyntQuill .ql-toolbar .ql-header.ql-picker .ql-picker-label,
.SaviyntQuill .ql-toolbar .ql-header.ql-picker .ql-picker-label .ql-stroke,
.SaviyntQuill .ql-toolbar .ql-header.ql-picker .ql-picker-label:hover,
.SaviyntQuill
  .ql-toolbar
  .ql-header.ql-picker
  .ql-picker-label:hover
  .ql-stroke {
  color: var(--color-foreground-neutral-bold, #212328);
  stroke: var(--color-foreground-neutral-bold, #212328);
}
.SaviyntQuill.SaviyntQuill .ql-bold,
.SaviyntQuill.SaviyntQuill .ql-italic,
.SaviyntQuill.SaviyntQuill .ql-underline,
.SaviyntQuill.SaviyntQuill .ql-image,
.SaviyntQuill.SaviyntQuill .ql-code-block,
.SaviyntQuill.SaviyntQuill .ql-list,
.SaviyntQuill.SaviyntQuill .ql-align,
.SaviyntQuill.SaviyntQuill .ql-picker-label,
.SaviyntQuill.SaviyntQuill .ql-indent,
.SaviyntQuill.SaviyntQuill .ql-link {
  color: var(--color-foreground-neutral-bold, #212328);
  border-radius: var(--border-radius-xs, 4px);
  transition: background var(--transition-fast-in-out);
}
/* Hover */
.SaviyntQuill.SaviyntQuill .ql-bold:hover,
.SaviyntQuill.SaviyntQuill .ql-italic:hover,
.SaviyntQuill.SaviyntQuill .ql-underline:hover,
.SaviyntQuill.SaviyntQuill .ql-image:hover,
.SaviyntQuill.SaviyntQuill .ql-code-block:hover,
.SaviyntQuill.SaviyntQuill .ql-list:hover,
.SaviyntQuill.SaviyntQuill .ql-align:hover,
.SaviyntQuill.SaviyntQuill .ql-picker-label:hover,
.SaviyntQuill.SaviyntQuill .ql-indent:hover,
.SaviyntQuill.SaviyntQuill .ql-link:hover {
  background: var(
    --color-background-primary-on-subtle-hover,
    rgba(55, 81, 255, 0.08)
  );
}
.SaviyntQuill.SaviyntQuill .ql-underline:hover .ql-fill,
.SaviyntQuill.SaviyntQuill .ql-image:hover .ql-fill,
.SaviyntQuill.SaviyntQuill .ql-list:hover .ql-fill,
.SaviyntQuill.SaviyntQuill .ql-picker-label:hover .ql-fill {
  fill: var(--color-foreground-primary-medium, #3751ff);
}
.SaviyntQuill.SaviyntQuill .ql-bold:hover .ql-stroke,
.SaviyntQuill.SaviyntQuill .ql-italic:hover .ql-stroke,
.SaviyntQuill.SaviyntQuill .ql-underline:hover .ql-stroke,
.SaviyntQuill.SaviyntQuill .ql-image:hover .ql-stroke,
.SaviyntQuill.SaviyntQuill .ql-image:hover .ql-even,
.SaviyntQuill.SaviyntQuill .ql-code-block:hover .ql-stroke,
.SaviyntQuill.SaviyntQuill .ql-list:hover .ql-stroke,
.SaviyntQuill.SaviyntQuill .ql-align:hover .ql-stroke,
.SaviyntQuill.SaviyntQuill .ql-picker-label:hover .ql-stroke,
.SaviyntQuill.SaviyntQuill .ql-indent:hover .ql-stroke,
.SaviyntQuill.SaviyntQuill .ql-link:hover .ql-stroke {
  stroke: var(--color-foreground-primary-medium, #3751ff);
}
.SaviyntQuill.SaviyntQuill .ql-underline:hover .ql-fill,
.SaviyntQuill.SaviyntQuill .ql-image:hover .ql-fill,
.SaviyntQuill.SaviyntQuill .ql-list:hover .ql-fill,
.SaviyntQuill.SaviyntQuill .ql-picker-label:hover .ql-fill {
  fill: var(--color-foreground-primary-medium, #3751ff);
}
/* Active */
.SaviyntQuill.SaviyntQuill .ql-active.ql-bold .ql-stroke,
.SaviyntQuill.SaviyntQuill .ql-active.ql-italic .ql-stroke,
.SaviyntQuill.SaviyntQuill .ql-active.ql-underline .ql-stroke,
.SaviyntQuill.SaviyntQuill .ql-active.ql-code-block .ql-stroke,
.SaviyntQuill.SaviyntQuill .ql-active.ql-list .ql-stroke,
.SaviyntQuill.SaviyntQuill .ql-active.ql-align .ql-stroke,
.SaviyntQuill.SaviyntQuill .ql-active.ql-link .ql-stroke {
  stroke: var(--color-foreground-primary-medium, #3751ff);
}
.SaviyntQuill.SaviyntQuill .ql-active.ql-underline .ql-fill,
.SaviyntQuill.SaviyntQuill .ql-active.ql-list .ql-fill {
  fill: var(--color-foreground-primary-medium, #3751ff);
}
.SaviyntQuill.SaviyntQuill .ql-active.ql-bold,
.SaviyntQuill.SaviyntQuill .ql-active.ql-italic,
.SaviyntQuill.SaviyntQuill .ql-active.ql-underline,
.SaviyntQuill.SaviyntQuill .ql-active.ql-code-block,
.SaviyntQuill.SaviyntQuill .ql-active.ql-list,
.SaviyntQuill.SaviyntQuill .ql-active.ql-align,
.SaviyntQuill.SaviyntQuill .ql-active.ql-link {
  background: var(
    --color-background-primary-on-subtle-selected,
    rgba(55, 81, 255, 0.1)
  );
}
/* Toolbar - menu items */
.SaviyntQuill.SaviyntQuill .ql-header.ql-picker .ql-picker-options,
.SaviyntQuill.SaviyntQuill
  .ql-toolbar
  .ql-picker.ql-expanded
  .ql-picker-options {
  padding: 0.75rem;
  border-radius: var(--border-radius-xs, 0.25rem);
  margin-top: 0.5rem;
  border: 0;
  border-radius: var(--border-radius-xs, 0.25rem);
  background: var(--color-background-neutral-subtlest, #fff);
  box-shadow: var(
    --box-shadow-container-interaction,
    var(
      --box-shadow-pretoken-container-interaction,
      0px 4px 16px 0px rgba(0, 0, 0, 0.2)
    )
  );
}
.SaviyntQuill.SaviyntQuill.SaviyntQuill .ql-toolbar + .ql-container {
  border: 0;
}
.SaviyntQuill.SaviyntQuill .ql-picker.ql-header .ql-picker-item {
  padding: 0.5rem 0.75rem;
  border-radius: var(--border-radius-xs, 0.25rem);
  transition: background var(--transition-fast-in-out);
}
.SaviyntQuill.SaviyntQuill .ql-picker.ql-header .ql-picker-item:hover {
  background: var(
    --color-background-primary-on-subtle-hover,
    rgba(55, 81, 255, 0.08)
  );
}

/* Editor */
.SaviyntQuill-editor {
  flex: 1 1 auto;
}
.SaviyntQuill-editor .ql-editor {
  background: var(--color-background-neutral-subtlest, #fff);
  border: 1px solid var(--color-border-secondary-subtlest, #cfd9e9);
  border-radius: 0 0 var(--border-radius-xs, 0.25rem)
    var(--border-radius-xs, 0.25rem);
  min-height: 18rem;
  padding: 0.75rem;
  transition: border var(--transition-fast-in-out);
}
/* Set all text default color to base Saviynt color */
.SaviyntQuill.SaviyntQuill .ql-picker.ql-header .ql-picker-item {
  color: var(--color-foreground-neutral-bold, #212328);
}

.SaviyntQuill li,
.SaviyntQuill p,
.SaviyntQuill.SaviyntQuill .ql-picker.ql-header .ql-picker-item {
  font: var(--typography-body-2);
  color: var(--color-foreground-neutral-bold, #212328);
}
.SaviyntQuill .SaviyntQuill-editor .ql-editor h1,
.SaviyntQuill.SaviyntQuill
  .ql-picker.ql-header
  .ql-picker-item[data-value='1']::before {
  font: var(--typography-heading-1);
  color: var(--color-foreground-neutral-bold, #212328);
}
.SaviyntQuill .SaviyntQuill-editor .ql-editor h2,
.SaviyntQuill.SaviyntQuill
  .ql-picker.ql-header
  .ql-picker-item[data-value='2']::before {
  font: var(--typography-heading-2);
  color: var(--color-foreground-neutral-bold, #212328);
}
.SaviyntQuill .SaviyntQuill-editor .ql-editor h3,
.SaviyntQuill.SaviyntQuill
  .ql-picker.ql-header
  .ql-picker-item[data-value='3']::before {
  font: var(--typography-heading-3);
  color: var(--color-foreground-neutral-bold, #212328);
}
.SaviyntQuill .SaviyntQuill-editor .ql-editor h4,
.SaviyntQuill.SaviyntQuill
  .ql-picker.ql-header
  .ql-picker-item[data-value='4']::before {
  font: var(--typography-heading-4);
  color: var(--color-foreground-neutral-bold, #212328);
}
.SaviyntQuill .SaviyntQuill-editor .ql-editor h5,
.SaviyntQuill.SaviyntQuill
  .ql-picker.ql-header
  .ql-picker-item[data-value='5']::before {
  font: var(--typography-heading-5);
  color: var(--color-foreground-neutral-bold, #212328);
}

/* Character count */
.SaviyntQuill-charCount {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 0.25rem;
}
.SaviyntQuill--isCritical .SaviyntQuill-charCount {
  justify-content: space-between;
}

/* ============ SaviyntRenderQuillDelta (Output) ============ */
.SaviyntRenderQuillDelta {
  width: 100%;
}
.SaviyntRenderQuillDelta li,
.SaviyntRenderQuillDelta p {
  font: var(--typography-body-2);
  color: var(--color-foreground-neutral-bold, #212328);
}
.SaviyntRenderQuillDelta h1 {
  font: var(--typography-heading-1);
  color: var(--color-foreground-neutral-bold, #212328);
}
.SaviyntRenderQuillDelta h2 {
  font: var(--typography-heading-2);
  color: var(--color-foreground-neutral-bold, #212328);
}
.SaviyntRenderQuillDelta h3 {
  font: var(--typography-heading-3);
  color: var(--color-foreground-neutral-bold, #212328);
}
.SaviyntRenderQuillDelta h4 {
  font: var(--typography-heading-4);
  color: var(--color-foreground-neutral-bold, #212328);
}
.SaviyntRenderQuillDelta h5 {
  font: var(--typography-heading-5);
  color: var(--color-foreground-neutral-bold, #212328);
}

/* Lists */
/* START -- Keep these in case Quill formatting breaks again */
/* .SaviyntRenderQuillDelta .ql-editor {
  padding-left: 0;
}
.SaviyntRenderQuillDelta .ql-editor ol,
.SaviyntRenderQuillDelta .ql-editor ul {
  padding-left: 1.5rem;
  list-style-position: inside;
}
.SaviyntRenderQuillDelta .ql-editor ol li,
.SaviyntRenderQuillDelta .ql-editor ul li {
  padding-left: 0;
}

.SaviyntRenderQuillDelta .ql-editor ul li {
  list-style-type: disc;
}
.SaviyntRenderQuillDelta .ql-editor ol li {
  list-style-type: decimal;
}
.SaviyntRenderQuillDelta .ql-editor ol ol li {
  list-style-type: lower-alpha;
}
.SaviyntRenderQuillDelta .ql-editor ol ol ol li {
  list-style-type: lower-roman;
}
.SaviyntRenderQuillDelta .ql-editor ol ol ol li {
  list-style-type: lower-greek;
}
.SaviyntRenderQuillDelta .ql-editor ol ol ol li {
  list-style-type: lower-latin;
} */
/* END -- Keep these in case Quill formatting breaks again */

/* Link -- Anchor */
.SaviyntQuill .SaviyntQuill-editor .ql-editor a,
.SaviyntRenderQuillDelta a {
  color: var(--color-foreground-primary-medium, #3751ff);
  text-decoration: none;
  transition: all var(--transition-fast-in-out);
  cursor: pointer;
}
.SaviyntQuill .SaviyntQuill-editor .ql-editor a:hover,
.SaviyntRenderQuillDelta a:hover {
  color: var(--color-foreground-primary-medium, #3751ff);
  text-decoration: underline;
}

/* Validation errors display */
.SaviyntQuill-validationErrors {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/SaviyntQuill/SaviyntQuill.css"],"names":[],"mappings":"AAAA,yEAAyE;AACzE,oDAAoD;AACpD;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;AACb;AACA;;;EAGE,aAAa;AACf;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA,YAAY;AACZ;EACE,8BAA8B;EAC9B,oDAAoD;EACpD,0DAA0D;EAC1D,iEAAiE;EACjE,gBAAgB;EAChB;wCACsC;AACxC;AACA;EACE,+CAA+C;EAC/C,+DAA+D;EAC/D;;;GAGC;AACH;AACA,qBAAqB;AACrB;EACE,8BAA8B;EAC9B,sDAAsD;AACxD;AACA,SAAS;AACT;;;;;EAKE,uDAAuD;AACzD;AACA;EACE;;;GAGC;AACH;AACA;;;;;;;;EAQE,oDAAoD;EACpD,qDAAqD;AACvD;AACA;;;;;;;;;;EAUE,oDAAoD;EACpD,2CAA2C;EAC3C,oDAAoD;AACtD;AACA,UAAU;AACV;;;;;;;;;;EAUE;;;GAGC;AACH;AACA;;;;EAIE,qDAAqD;AACvD;AACA;;;;;;;;;;;EAWE,uDAAuD;AACzD;AACA;;;;EAIE,qDAAqD;AACvD;AACA,WAAW;AACX;;;;;;;EAOE,uDAAuD;AACzD;AACA;;EAEE,qDAAqD;AACvD;AACA;;;;;;;EAOE;;;GAGC;AACH;AACA,yBAAyB;AACzB;;;;;EAKE,gBAAgB;EAChB,+CAA+C;EAC/C,kBAAkB;EAClB,SAAS;EACT,+CAA+C;EAC/C,0DAA0D;EAC1D;;;;;;GAMC;AACH;AACA;EACE,SAAS;AACX;AACA;EACE,uBAAuB;EACvB,+CAA+C;EAC/C,oDAAoD;AACtD;AACA;EACE;;;GAGC;AACH;;AAEA,WAAW;AACX;EACE,cAAc;AAChB;AACA;EACE,0DAA0D;EAC1D,iEAAiE;EACjE;oCACkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,gDAAgD;AAClD;AACA,qDAAqD;AACrD;EACE,oDAAoD;AACtD;;AAEA;;;EAGE,8BAA8B;EAC9B,oDAAoD;AACtD;AACA;;;;EAIE,iCAAiC;EACjC,oDAAoD;AACtD;AACA;;;;EAIE,iCAAiC;EACjC,oDAAoD;AACtD;AACA;;;;EAIE,iCAAiC;EACjC,oDAAoD;AACtD;AACA;;;;EAIE,iCAAiC;EACjC,oDAAoD;AACtD;AACA;;;;EAIE,iCAAiC;EACjC,oDAAoD;AACtD;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;;AAEA,+DAA+D;AAC/D;EACE,WAAW;AACb;AACA;;EAEE,8BAA8B;EAC9B,oDAAoD;AACtD;AACA;EACE,iCAAiC;EACjC,oDAAoD;AACtD;AACA;EACE,iCAAiC;EACjC,oDAAoD;AACtD;AACA;EACE,iCAAiC;EACjC,oDAAoD;AACtD;AACA;EACE,iCAAiC;EACjC,oDAAoD;AACtD;AACA;EACE,iCAAiC;EACjC,oDAAoD;AACtD;;AAEA,UAAU;AACV,8DAA8D;AAC9D;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA8BG;AACH,4DAA4D;;AAE5D,mBAAmB;AACnB;;EAEE,sDAAsD;EACtD,qBAAqB;EACrB,6CAA6C;EAC7C,eAAe;AACjB;AACA;;EAEE,sDAAsD;EACtD,0BAA0B;AAC5B;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB","sourcesContent":["/* This file is shared between SaviyntQuill and SaviyntRenderQuillDelta */\n/* ============ SaviyntQuill (Editor) ============ */\n.SaviyntQuill {\n  display: flex;\n  flex-direction: column;\n  min-height: 20rem;\n  width: 100%;\n}\n.SaviyntQuill--isQuillInitializing .SaviyntQuill-editor,\n.SaviyntQuill--isQuillInitializing .ql-toolbar,\n.SaviyntRenderQuillDelta--isQuillInitializing .ql-editor {\n  display: none;\n}\n.SaviyntQuill-loading,\n.SaviyntRenderQuillDelta-loading {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  min-height: 20rem;\n  height: 100%;\n  width: 100%;\n}\n.SaviyntRenderQuillDelta-loading {\n  min-height: 3rem;\n}\n/* Toolbar */\n.SaviyntQuill.SaviyntQuill .ql-toolbar {\n  font: var(--typography-body-2);\n  color: var(--color-foreground-neutral-bold, #212328);\n  background: var(--color-background-neutral-subtlest, #fff);\n  border: 1px solid var(--color-border-secondary-subtlest, #cfd9e9);\n  border-bottom: 0;\n  border-radius: var(--border-radius-xs, 0.25rem)\n    var(--border-radius-xs, 0.25rem) 0 0;\n}\n.SaviyntQuill.SaviyntQuill .ql-toolbar .ql-picker.ql-expanded .ql-picker-label {\n  border-radius: var(--border-radius-xs, 0.25rem);\n  border: 1px solid var(--color-border-secondary-medium, #254b86);\n  background: var(\n    --color-background-secondary-on-subtle-selected,\n    rgba(37, 75, 134, 0.1)\n  );\n}\n/* Placeholder text */\n.SaviyntQuill .ql-editor.ql-blank::before {\n  font: var(--typography-body-2);\n  color: var(--color-foreground-neutral-subtle, #717385);\n}\n/* Base */\n.SaviyntQuill.SaviyntQuill .ql-stroke,\n.SaviyntQuill.SaviyntQuill .ql-color .ql-picker-label svg .ql-stroke,\n.SaviyntQuill.SaviyntQuill .ql-background .ql-picker-label svg .ql-stroke,\n.SaviyntQuill.SaviyntQuill .ql-even,\n.SaviyntQuill.SaviyntQuill .ql-fill {\n  stroke: var(--color-foreground-primary-medium, #3751ff);\n}\n.SaviyntQuill.SaviyntQuill g.ql-fill {\n  stroke: var(\n    --color-background-neutral-on-bold-hover,\n    rgba(255, 255, 255, 0.24)\n  );\n}\n.SaviyntQuill .ql-toolbar .ql-header.ql-picker .ql-picker-label,\n.SaviyntQuill .ql-toolbar .ql-header.ql-picker .ql-picker-label .ql-stroke,\n.SaviyntQuill .ql-toolbar .ql-header.ql-picker .ql-picker-label:hover,\n.SaviyntQuill\n  .ql-toolbar\n  .ql-header.ql-picker\n  .ql-picker-label:hover\n  .ql-stroke {\n  color: var(--color-foreground-neutral-bold, #212328);\n  stroke: var(--color-foreground-neutral-bold, #212328);\n}\n.SaviyntQuill.SaviyntQuill .ql-bold,\n.SaviyntQuill.SaviyntQuill .ql-italic,\n.SaviyntQuill.SaviyntQuill .ql-underline,\n.SaviyntQuill.SaviyntQuill .ql-image,\n.SaviyntQuill.SaviyntQuill .ql-code-block,\n.SaviyntQuill.SaviyntQuill .ql-list,\n.SaviyntQuill.SaviyntQuill .ql-align,\n.SaviyntQuill.SaviyntQuill .ql-picker-label,\n.SaviyntQuill.SaviyntQuill .ql-indent,\n.SaviyntQuill.SaviyntQuill .ql-link {\n  color: var(--color-foreground-neutral-bold, #212328);\n  border-radius: var(--border-radius-xs, 4px);\n  transition: background var(--transition-fast-in-out);\n}\n/* Hover */\n.SaviyntQuill.SaviyntQuill .ql-bold:hover,\n.SaviyntQuill.SaviyntQuill .ql-italic:hover,\n.SaviyntQuill.SaviyntQuill .ql-underline:hover,\n.SaviyntQuill.SaviyntQuill .ql-image:hover,\n.SaviyntQuill.SaviyntQuill .ql-code-block:hover,\n.SaviyntQuill.SaviyntQuill .ql-list:hover,\n.SaviyntQuill.SaviyntQuill .ql-align:hover,\n.SaviyntQuill.SaviyntQuill .ql-picker-label:hover,\n.SaviyntQuill.SaviyntQuill .ql-indent:hover,\n.SaviyntQuill.SaviyntQuill .ql-link:hover {\n  background: var(\n    --color-background-primary-on-subtle-hover,\n    rgba(55, 81, 255, 0.08)\n  );\n}\n.SaviyntQuill.SaviyntQuill .ql-underline:hover .ql-fill,\n.SaviyntQuill.SaviyntQuill .ql-image:hover .ql-fill,\n.SaviyntQuill.SaviyntQuill .ql-list:hover .ql-fill,\n.SaviyntQuill.SaviyntQuill .ql-picker-label:hover .ql-fill {\n  fill: var(--color-foreground-primary-medium, #3751ff);\n}\n.SaviyntQuill.SaviyntQuill .ql-bold:hover .ql-stroke,\n.SaviyntQuill.SaviyntQuill .ql-italic:hover .ql-stroke,\n.SaviyntQuill.SaviyntQuill .ql-underline:hover .ql-stroke,\n.SaviyntQuill.SaviyntQuill .ql-image:hover .ql-stroke,\n.SaviyntQuill.SaviyntQuill .ql-image:hover .ql-even,\n.SaviyntQuill.SaviyntQuill .ql-code-block:hover .ql-stroke,\n.SaviyntQuill.SaviyntQuill .ql-list:hover .ql-stroke,\n.SaviyntQuill.SaviyntQuill .ql-align:hover .ql-stroke,\n.SaviyntQuill.SaviyntQuill .ql-picker-label:hover .ql-stroke,\n.SaviyntQuill.SaviyntQuill .ql-indent:hover .ql-stroke,\n.SaviyntQuill.SaviyntQuill .ql-link:hover .ql-stroke {\n  stroke: var(--color-foreground-primary-medium, #3751ff);\n}\n.SaviyntQuill.SaviyntQuill .ql-underline:hover .ql-fill,\n.SaviyntQuill.SaviyntQuill .ql-image:hover .ql-fill,\n.SaviyntQuill.SaviyntQuill .ql-list:hover .ql-fill,\n.SaviyntQuill.SaviyntQuill .ql-picker-label:hover .ql-fill {\n  fill: var(--color-foreground-primary-medium, #3751ff);\n}\n/* Active */\n.SaviyntQuill.SaviyntQuill .ql-active.ql-bold .ql-stroke,\n.SaviyntQuill.SaviyntQuill .ql-active.ql-italic .ql-stroke,\n.SaviyntQuill.SaviyntQuill .ql-active.ql-underline .ql-stroke,\n.SaviyntQuill.SaviyntQuill .ql-active.ql-code-block .ql-stroke,\n.SaviyntQuill.SaviyntQuill .ql-active.ql-list .ql-stroke,\n.SaviyntQuill.SaviyntQuill .ql-active.ql-align .ql-stroke,\n.SaviyntQuill.SaviyntQuill .ql-active.ql-link .ql-stroke {\n  stroke: var(--color-foreground-primary-medium, #3751ff);\n}\n.SaviyntQuill.SaviyntQuill .ql-active.ql-underline .ql-fill,\n.SaviyntQuill.SaviyntQuill .ql-active.ql-list .ql-fill {\n  fill: var(--color-foreground-primary-medium, #3751ff);\n}\n.SaviyntQuill.SaviyntQuill .ql-active.ql-bold,\n.SaviyntQuill.SaviyntQuill .ql-active.ql-italic,\n.SaviyntQuill.SaviyntQuill .ql-active.ql-underline,\n.SaviyntQuill.SaviyntQuill .ql-active.ql-code-block,\n.SaviyntQuill.SaviyntQuill .ql-active.ql-list,\n.SaviyntQuill.SaviyntQuill .ql-active.ql-align,\n.SaviyntQuill.SaviyntQuill .ql-active.ql-link {\n  background: var(\n    --color-background-primary-on-subtle-selected,\n    rgba(55, 81, 255, 0.1)\n  );\n}\n/* Toolbar - menu items */\n.SaviyntQuill.SaviyntQuill .ql-header.ql-picker .ql-picker-options,\n.SaviyntQuill.SaviyntQuill\n  .ql-toolbar\n  .ql-picker.ql-expanded\n  .ql-picker-options {\n  padding: 0.75rem;\n  border-radius: var(--border-radius-xs, 0.25rem);\n  margin-top: 0.5rem;\n  border: 0;\n  border-radius: var(--border-radius-xs, 0.25rem);\n  background: var(--color-background-neutral-subtlest, #fff);\n  box-shadow: var(\n    --box-shadow-container-interaction,\n    var(\n      --box-shadow-pretoken-container-interaction,\n      0px 4px 16px 0px rgba(0, 0, 0, 0.2)\n    )\n  );\n}\n.SaviyntQuill.SaviyntQuill.SaviyntQuill .ql-toolbar + .ql-container {\n  border: 0;\n}\n.SaviyntQuill.SaviyntQuill .ql-picker.ql-header .ql-picker-item {\n  padding: 0.5rem 0.75rem;\n  border-radius: var(--border-radius-xs, 0.25rem);\n  transition: background var(--transition-fast-in-out);\n}\n.SaviyntQuill.SaviyntQuill .ql-picker.ql-header .ql-picker-item:hover {\n  background: var(\n    --color-background-primary-on-subtle-hover,\n    rgba(55, 81, 255, 0.08)\n  );\n}\n\n/* Editor */\n.SaviyntQuill-editor {\n  flex: 1 1 auto;\n}\n.SaviyntQuill-editor .ql-editor {\n  background: var(--color-background-neutral-subtlest, #fff);\n  border: 1px solid var(--color-border-secondary-subtlest, #cfd9e9);\n  border-radius: 0 0 var(--border-radius-xs, 0.25rem)\n    var(--border-radius-xs, 0.25rem);\n  min-height: 18rem;\n  padding: 0.75rem;\n  transition: border var(--transition-fast-in-out);\n}\n/* Set all text default color to base Saviynt color */\n.SaviyntQuill.SaviyntQuill .ql-picker.ql-header .ql-picker-item {\n  color: var(--color-foreground-neutral-bold, #212328);\n}\n\n.SaviyntQuill li,\n.SaviyntQuill p,\n.SaviyntQuill.SaviyntQuill .ql-picker.ql-header .ql-picker-item {\n  font: var(--typography-body-2);\n  color: var(--color-foreground-neutral-bold, #212328);\n}\n.SaviyntQuill .SaviyntQuill-editor .ql-editor h1,\n.SaviyntQuill.SaviyntQuill\n  .ql-picker.ql-header\n  .ql-picker-item[data-value='1']::before {\n  font: var(--typography-heading-1);\n  color: var(--color-foreground-neutral-bold, #212328);\n}\n.SaviyntQuill .SaviyntQuill-editor .ql-editor h2,\n.SaviyntQuill.SaviyntQuill\n  .ql-picker.ql-header\n  .ql-picker-item[data-value='2']::before {\n  font: var(--typography-heading-2);\n  color: var(--color-foreground-neutral-bold, #212328);\n}\n.SaviyntQuill .SaviyntQuill-editor .ql-editor h3,\n.SaviyntQuill.SaviyntQuill\n  .ql-picker.ql-header\n  .ql-picker-item[data-value='3']::before {\n  font: var(--typography-heading-3);\n  color: var(--color-foreground-neutral-bold, #212328);\n}\n.SaviyntQuill .SaviyntQuill-editor .ql-editor h4,\n.SaviyntQuill.SaviyntQuill\n  .ql-picker.ql-header\n  .ql-picker-item[data-value='4']::before {\n  font: var(--typography-heading-4);\n  color: var(--color-foreground-neutral-bold, #212328);\n}\n.SaviyntQuill .SaviyntQuill-editor .ql-editor h5,\n.SaviyntQuill.SaviyntQuill\n  .ql-picker.ql-header\n  .ql-picker-item[data-value='5']::before {\n  font: var(--typography-heading-5);\n  color: var(--color-foreground-neutral-bold, #212328);\n}\n\n/* Character count */\n.SaviyntQuill-charCount {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  margin-top: 0.25rem;\n}\n.SaviyntQuill--isCritical .SaviyntQuill-charCount {\n  justify-content: space-between;\n}\n\n/* ============ SaviyntRenderQuillDelta (Output) ============ */\n.SaviyntRenderQuillDelta {\n  width: 100%;\n}\n.SaviyntRenderQuillDelta li,\n.SaviyntRenderQuillDelta p {\n  font: var(--typography-body-2);\n  color: var(--color-foreground-neutral-bold, #212328);\n}\n.SaviyntRenderQuillDelta h1 {\n  font: var(--typography-heading-1);\n  color: var(--color-foreground-neutral-bold, #212328);\n}\n.SaviyntRenderQuillDelta h2 {\n  font: var(--typography-heading-2);\n  color: var(--color-foreground-neutral-bold, #212328);\n}\n.SaviyntRenderQuillDelta h3 {\n  font: var(--typography-heading-3);\n  color: var(--color-foreground-neutral-bold, #212328);\n}\n.SaviyntRenderQuillDelta h4 {\n  font: var(--typography-heading-4);\n  color: var(--color-foreground-neutral-bold, #212328);\n}\n.SaviyntRenderQuillDelta h5 {\n  font: var(--typography-heading-5);\n  color: var(--color-foreground-neutral-bold, #212328);\n}\n\n/* Lists */\n/* START -- Keep these in case Quill formatting breaks again */\n/* .SaviyntRenderQuillDelta .ql-editor {\n  padding-left: 0;\n}\n.SaviyntRenderQuillDelta .ql-editor ol,\n.SaviyntRenderQuillDelta .ql-editor ul {\n  padding-left: 1.5rem;\n  list-style-position: inside;\n}\n.SaviyntRenderQuillDelta .ql-editor ol li,\n.SaviyntRenderQuillDelta .ql-editor ul li {\n  padding-left: 0;\n}\n\n.SaviyntRenderQuillDelta .ql-editor ul li {\n  list-style-type: disc;\n}\n.SaviyntRenderQuillDelta .ql-editor ol li {\n  list-style-type: decimal;\n}\n.SaviyntRenderQuillDelta .ql-editor ol ol li {\n  list-style-type: lower-alpha;\n}\n.SaviyntRenderQuillDelta .ql-editor ol ol ol li {\n  list-style-type: lower-roman;\n}\n.SaviyntRenderQuillDelta .ql-editor ol ol ol li {\n  list-style-type: lower-greek;\n}\n.SaviyntRenderQuillDelta .ql-editor ol ol ol li {\n  list-style-type: lower-latin;\n} */\n/* END -- Keep these in case Quill formatting breaks again */\n\n/* Link -- Anchor */\n.SaviyntQuill .SaviyntQuill-editor .ql-editor a,\n.SaviyntRenderQuillDelta a {\n  color: var(--color-foreground-primary-medium, #3751ff);\n  text-decoration: none;\n  transition: all var(--transition-fast-in-out);\n  cursor: pointer;\n}\n.SaviyntQuill .SaviyntQuill-editor .ql-editor a:hover,\n.SaviyntRenderQuillDelta a:hover {\n  color: var(--color-foreground-primary-medium, #3751ff);\n  text-decoration: underline;\n}\n\n/* Validation errors display */\n.SaviyntQuill-validationErrors {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
